import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Slider, Stack, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import moment, { Moment } from 'moment';
import { v4 as uuid } from 'uuid'

const TimerHandler = (props: ITimerHandlerProps) => {

    const { payload, onClose, onSubmit, open, type } = props;
    const [discount, setDiscount] = useState<number>(50);
    const [dateFrom, setDateFrom] = useState<Moment | null>(null);
    const [dateTo, setDateTo] = useState<Moment | null>(null);

    useEffect(() => {
        if (payload === undefined) {
            setDiscount(50);
            setDateFrom(null);
            setDateTo(null);
        } else {
            setDiscount(payload.discountPercent);
            setDateFrom(moment(payload.activation.dateFrom));
            setDateTo(moment(payload.activation.dateTo));
        }
    }, [payload, open]);

    const isDisabled =
        dateFrom === null ||
        dateTo === null ||
        moment(dateFrom).isValid() === false ||
        moment(dateTo).isValid() === false;

    const handleOnSubmit = () => {
        if (isDisabled) return;

        const id = payload === undefined ? uuid() : payload.id;
        onSubmit({
            id: id,
            discountPercent: discount,
            activation: {
                dateFrom: dateFrom.toDate(),
                dateTo: dateTo.toDate()
            }
        });

        onClose();
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            {type === 'EDIT' && <DialogTitle>Actualizar temporizador</DialogTitle>}
            {type === 'NEW' && <DialogTitle>Agregar temporizador</DialogTitle>}
            <DialogContent dividers>
                <Stack spacing={5}>
                    <Stack spacing={1}>
                        <Typography variant="h6">
                            Descuento
                        </Typography>
                        <Typography variant="subtitle1">
                            Define el porcentaje del descuento
                        </Typography>
                        <Box
                            component="section"
                            sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    pr: 2
                                }}>
                                {discount}%
                            </Typography>
                            <Slider
                                value={discount}
                                onChange={(event, value) => {
                                    setDiscount(value as number);
                                }}
                                aria-label="Default"
                                valueLabelDisplay="off"
                                valueLabelFormat={(value) => `${value}%`}
                            />
                        </Box>
                    </Stack>
                    <Stack spacing={1}>
                        <Typography variant="h6">
                            Inicio
                        </Typography>
                        <Typography variant="subtitle1">
                            Define la fecha y hora de inicio
                        </Typography>
                        <DateTimePicker
                            value={dateFrom}
                            onChange={(value) => {
                                setDateFrom(value);
                            }}
                            label="Inicio"
                            viewRenderers={{
                                hours: null,
                                minutes: null,
                                seconds: null,
                            }}
                        />
                    </Stack>
                    <Stack spacing={1}>
                        <Typography variant="h6">
                            Fin
                        </Typography>
                        <Typography variant="subtitle1">
                            Define la fecha y hora de fin
                        </Typography>
                        <DateTimePicker
                            value={dateTo}
                            onChange={(value) => {
                                setDateTo(value);
                            }}
                            label="Fin"
                            viewRenderers={{
                                hours: null,
                                minutes: null,
                                seconds: null,
                            }}
                        />
                    </Stack>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Stack spacing={2} direction='row'>
                    <Button onClick={onClose}>Cancelar</Button>
                    {type === 'EDIT' &&
                        <Button
                            onClick={handleOnSubmit}
                            disabled={isDisabled}>
                            Actualizar
                        </Button>}
                    {type === 'NEW' &&
                        <Button
                            onClick={handleOnSubmit}
                            disabled={isDisabled}>
                            Agregar
                        </Button>}
                </Stack>
            </DialogActions>
        </Dialog>
    );
}

export { TimerHandler };